import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ToastService } from '@utils/toast.service';
import { TableModule } from 'primeng/table';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { ImssService } from '@services/imss.service';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'page-enviar-email',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    TableModule,
    InputGroupAddonModule,
    InputGroup,
    IconFieldModule,
    InputIconModule,
    InputMaskModule,
    DialogModule,
    TagModule,
  ],
  templateUrl: './enviar-email.component.html',
  styleUrl: './enviar-email.component.scss',
})
export class EnviarEmailComponent {
  private formBuilder = inject(FormBuilder);
  private imssService = inject(ImssService);
  private toastService = inject(ToastService);

  public isSaving = false;
  public statusModalDetails = false;
  public statusModalError = false;

  public formUpload = this.formBuilder.group({
    curp: [null, Validators.required],
    email: [null, [Validators.required, Validators.email]],
  });

  public list: any[] = [];
  public itemDetails: any = [];
  public itemError: any = [];
  public searchValue: string | undefined;

  ngOnInit() {
    this.refresh();
  }

  refresh = async () => {
    await this.imssService.semanasCotizadasList('internal').then((response) => (this.list = response));
  };

  get curp() {
    return this.formUpload.get('curp');
  }
  set curp(value: any) {
    this.curp.setValue(value);
  }

  get email() {
    return this.formUpload.get('email');
  }
  set email(value: any) {
    this.email.setValue(value);
  }

  request = async () => {
    this.isSaving = true;

    this.imssService
      .semanasCotizadasSolicitar(this.formUpload.value)
      .then(() => {
        this.toastService.success('Solicitud enviada.');
        this.formUpload.reset();
        this.refresh();
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error.');
      })
      .finally(() => (this.isSaving = false));
  };

  viewDetails = (item: any) => {
    this.statusModalDetails = true;
    this.itemDetails = item;
  };

  showError = (error: string) => {
    this.statusModalError = true;
    this.itemError = error;
  };
}
